/* eslint-disable prettier/prettier */
import React from "react";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import { Card, Typography, Box } from "@mui/material";

export default function Dashboard() {
  // Get the logged-in user's email to say hello!
  const userEmail = localStorage.getItem("userEmail") || "مستخدم";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ pt: 8, direction: "rtl", textAlign: "center" }}>
        <Card sx={{ p: 6, borderRadius: "15px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", maxWidth: "600px", margin: "0 auto" }}>
          <Typography variant="h3" fontWeight="bold" color="#1A73E8" mb={2}>
            مرحباً بك في لوحة تحكم مستر وفايي
          </Typography>
          <Typography variant="h6" color="textSecondary" sx={{ lineHeight: 1.6 }}>
            أهلاً بك، {userEmail}. <br />
            لقد قمت بتسجيل الدخول بنجاح. يرجى اختيار القسم الذي ترغب في إدارته من القائمة الجانبية.
          </Typography>
        </Card>
      </Box>
    </DashboardLayout>
  );
}